var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.msg))]),_c('v-btn',{staticClass:"clickable",attrs:{"text":""},on:{"click":_vm.goto}},[_vm._v(_vm._s(_vm.clickableTxt))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }